import api from './api';

export const getPortalProfile = () =>
  api.get('/api/v1/portal/profile').then((r) => r.data.data);

export const getPortalAppointments = () =>
  api.get('/api/v1/portal/appointments').then((r) => r.data.data);

export const getPortalInvoices = () =>
  api.get('/api/v1/portal/invoices').then((r) => r.data.data.invoices);

export const getPortalInvoice = (id) =>
  api.get(`/api/v1/portal/invoices/${id}`).then((r) => r.data.data.invoice);

export const getPortalDocuments = () =>
  api.get('/api/v1/portal/documents').then((r) => r.data.data.documents);

export const createPortalCheckout = (invoiceId) =>
  api.post(`/api/v1/portal/invoices/${invoiceId}/checkout`).then((r) => r.data.data.url);

export const createPortalAchIntent = (invoiceId) =>
  api.post(`/api/v1/portal/invoices/${invoiceId}/ach-intent`).then((r) => r.data);

export const getPortalPaymentConfig = () =>
  api.get('/api/v1/portal/payment-config').then((r) => r.data.data);

export const uploadPortalDocument = (file, description) => {
  const form = new FormData();
  form.append('file', file);
  if (description) form.append('description', description);
  return api.post('/api/v1/portal/documents', form).then((r) => r.data.data.document);
};

export const getPortalAppointmentTypes = () =>
  api.get('/api/v1/portal/appointment-types').then((r) => r.data.data.appointmentTypes);

export const getPortalAvailability = (date, appointmentTypeId) =>
  api.get('/api/v1/portal/availability', { params: { date, appointmentTypeId } }).then((r) => r.data.data);

export const bookPortalAppointment = (data) =>
  api.post('/api/v1/portal/schedule', data).then((r) => r.data);

export const joinPortalTelehealthRoom = (appointmentId) =>
  api.get(`/api/v1/portal/appointments/${appointmentId}/join`).then((r) => r.data.data);

export const getPortalIntakeForms = () =>
  api.get('/api/v1/portal/intake-forms').then((r) => r.data.data.responses);

export const getPortalIntakeForm = (responseId) =>
  api.get(`/api/v1/portal/intake-forms/${responseId}`).then((r) => r.data.data.response);

export const submitPortalIntakeForm = (responseId, data) =>
  api.post(`/api/v1/portal/intake-forms/${responseId}/submit`, data).then((r) => r.data);

export const downloadPortalDocument = async (id, fileName) => {
  const response = await api.get(`/api/v1/portal/documents/${id}/download`, {
    responseType: 'blob',
  });
  const url = URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
